import parseInteger from './parseInteger';

export default function calculateCurrentPage(offset, limit) {
    return parseInteger((parseInteger(offset) + parseInteger(limit)) / parseInteger(limit));
}